export default {
  namespaced: true,
  state: {
    items: [],
  },
  // getters: {
  //   getAll: state => state.items,
  //   getItem: state => id => state.items.find(item => item.id == id)
  // },
  actions: {

    /**
     * Cette fonction est vide mais nécessaire car appelée automatiquement par le store parent. Sinon ça génère une erreur
     */
    getAll: (context, wait = false) => {

    },
    addItem(context, item) {
      let formData = new FormData();
      for (var index in item) {
        if (item[index]) {
          formData.append(index, item[index]);
        }
      }

      let params = {
        api_url: 'document',
        namespace: 'documents',
        item: item,
        formData: formData
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'document',
        namespace: 'documents',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/document.js